import { createContext, useContext } from 'react';
import type { PathMatch } from 'react-router-dom';

import { Sport } from '__generated__/globalTypes';
import type { AnalyticTag } from 'components/search/InstantSearch/types';
import type { PathParams } from 'lib/routing/generateSportPath';

type GenerateSportPathFunctionType = <Path extends string>(
  path: Path,
  options?: {
    params?: PathParams<Path>;
    sport?: Sport;
  }
) => string;

export const sportAnalyticTag: Record<Sport, AnalyticTag> = {
  [Sport.FOOTBALL]: 'Football',
  [Sport.NBA]: 'NBA',
  [Sport.BASEBALL]: 'MLB',
};

export interface SportContext {
  sport: Sport;
  sportAnalyticsTag: AnalyticTag;
  setSport: (sport: Sport) => void;
  generateSportContextPath: GenerateSportPathFunctionType;
  matchAnySportPath: (
    pattern: string,
    pathname: string,
    sport?: Sport
  ) => PathMatch<string> | null;
}

export const SportContext = createContext<SportContext | null>(null);

export const useSportContext = () => useContext(SportContext)!;
